import React, { useState, useEffect, memo } from 'react';

/**
 * ClientOnly - Renders children only on the client side
 * Prevents SSR issues with components that use window, document, or browser-only APIs
 * Memoized to prevent unnecessary re-renders
 * 
 * Usage:
 * <ClientOnly>
 *   <ComponentThatUsesWindow />
 * </ClientOnly>
 */
const ClientOnly = memo(({ children, fallback = null }) => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return fallback;
  }

  return <>{children}</>;
});

ClientOnly.displayName = 'ClientOnly';

export default ClientOnly;
